import { Button, Modal, Typography } from "antd";
import React, { useEffect, useState } from "react";
import BrandLogoService from "services/BrandLogoService";
import { FaCrown } from "react-icons/fa";
import { DialogTitle } from "@mui/material";
import LearningService from "services/LearningService";

function UpgradeNav() {
  const [upgardeModal, setUpgradeModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [accountType, setAccountType] = useState();
  const [calendlyModal, setCalendlyModal] = useState(false);

  const getCompanyData = () => {
    const getCompanyDetails = BrandLogoService.getCompanyLogo;
    Promise.resolve(getCompanyDetails()).then((res) => {
      setAccountType(res?.data?.Data?.AccountType);
    });
  };

  useEffect(() => {
    getCompanyData();
  }, []);

  const fetchCourseData = () => {
    const viewCourses = LearningService.GetAllCoursesByCompany;
    Promise.resolve(viewCourses(page - 1, search, pageSize)).then((result) => {
      setProgress(result?.TotalRecords);
    });
  };

  useEffect(() => {
    fetchCourseData();
  }, []);

  const handleOpenUpgradeModal = () => {
    setUpgradeModal(true);
    fetchCourseData();
  };

  const getProgressBarColor = () => {
    if (progress === 0) {
      return "#D8DEE3";
    } else if (progress >= 1 && progress <= 4) {
      return "#FFC107";
    } else if ((progress >= 5 ? 5 : progress) === 5) {
      return "#E2483C";
    } else {
      return "#D8DEE3";
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", marginRight: "1rem" }}>
      {(accountType === "free" || accountType === "Free") && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            onClick={handleOpenUpgradeModal}
            type="primary"
            style={{
              display: "flex",
              flexDirection: "row",
              columnGap: "5px",
              alignItems: "center",
              justifyContent: "center",
              width: "125px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#fff",
              backgroundColor: "#4D78EF",
            }}
          >
            <FaCrown style={{ width: "20px" }} />
            Upgrade
          </Button>
        </div>
      )}

      <Modal
        visible={upgardeModal}
        width="600px"
        footer={false}
        title={
          <DialogTitle
            sx={{ padding: "0px", fontWeight: 600, color: "#293845" }}
          >
            Upgrade to Paid Account
          </DialogTitle>
        }
        onCancel={() => setUpgradeModal(false)}
      >
        <div>
          <Typography
            style={{
              fontWeight: "400",
              fontSize: "16px",
              color: "#293845",
              marginBottom: "1rem",
              fontFamily: "",
            }}
          >
            {progress >= 5
              ? "You have consumed your free trial limit of 5 courses. Upgrade to continue to add courses."
              : `You are on free trial with limit of 5 Free courses. Your Free-trial ends after ${
                  5 - (progress >= 5 ? 5 : progress)
                } ${
                  5 - (progress >= 5 ? 5 : progress) === 1
                    ? "course"
                    : "courses"
                }`}
          </Typography>
          <Typography
            style={{
              fontWeight: "800",
              fontSize: "14px",
              color: "#293845",
              marginBottom: "3px",
            }}
          >
            {progress !== 5
              ? `${5 - (progress >= 5 ? 5 : progress)} ${
                  5 - (progress >= 5 ? 5 : progress) === 1
                    ? "course"
                    : "courses"
                } left`
              : "No Courses left"}
          </Typography>
          <div
            style={{
              width: "100%",
              backgroundColor: "#D8DEE3",
              position: "relative",
              height: "25px",
              display: "flex",
              alignItems: "center",
              borderRadius: "2px",
              marginBottom: "1rem",
            }}
          >
            <div
              style={{
                width: `${(progress === 0 ? 5 : progress / 5) * 100}%`,
                height: "20px",
                backgroundColor: getProgressBarColor(),
                height: "25px",
                borderRadius: "2px",
              }}
            ></div>
            <Typography
              style={{
                color: progress === 5 ? "#FFF" : "#293845",
                fontWeight: "500",
                fontSize: "14px",
                position: "absolute",
                right: "7px",
              }}
            >
              {progress >= 5 ? 5 : progress}/5
            </Typography>
          </div>
          <Typography
            style={{ fontWeight: "400", fontSize: "16px", color: "#293845" }}
          >
            Talk to sales to upgrade now for unlimited courses
          </Typography>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "3rem",
            }}
          >
            <Button
              type="primary"
              style={{
                display: "flex",
                flexDirection: "row",
                columnGap: "5px",
                alignItems: "center",
                justifyContent: "center",
                width: "fit-content",
                fontSize: "14px",
                fontWeight: "600",
                color: "#4D78EF",
                backgroundColor: "#FFF",
              }}
              onClick={() => setUpgradeModal(false)}
            >
              <a href="https://www.accrue.club/" target="_blank">
                Know more
              </a>
            </Button>
            <Button
              type="primary"
              style={{
                display: "flex",
                flexDirection: "row",
                columnGap: "5px",
                alignItems: "center",
                justifyContent: "center",
                width: "fit-content",
                fontSize: "14px",
                fontWeight: "600",
                color: "#fff",
                backgroundColor: "#4D78EF",
              }}
              onClick={() => setCalendlyModal(true)}
            >
              Talk to Sales
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        title="Schedule a Meeting"
        visible={calendlyModal}
        onCancel={() => setCalendlyModal(false)}
        width="90%"
        footer={null} // No footer buttons
      >
        <iframe
          src="https://calendly.com/vinayak-accrue/30min?hide_gdpr_banner=1&primary_color=4b2ef1"
          width="100%"
          height="600px"
          frameborder="0"
        ></iframe>
      </Modal>
    </div>
  );
}

export default UpgradeNav;
